import { Constant } from '@shared/constants'
import AdviseTag from '@img/student/ad-advise-tag.png'
import AigcTag from '@img/student/ad-aigc-tag.png'
import AigcReduceTag from '@img/student/ad-aigc-reduce-tag.png'
import CoachTag from '@img/student/ad-coach-tag.png'
import CorrectionTag from '@img/student/ad-correction-tag.png'
import DetectionTag from '@img/student/ad-detection-tag.png'
import RepetitionReduceTag from '@img/student/ad-repetition-reduce-tag.png'
import PaperDefenseTag from '@img/student/ad-paper-defense-tag.png'

import AssistantAdviseTag from '@img/student/assistant-advise-tag.png'
import AssistantCoachTag from '@img/student/assistant-coach-tag.png'
import AssistantCorrectionTag from '@img/student/assistant-correction-tag.png'
import AssistantAigcTag from '@img/student/assistant-aigc-tag.png'
import AssistantDetectionTag from '@img/student/assistant-detection-tag.png'
import AssistantAigcreduceTag from '@img/student/assistant-aigc-reduce-tag.png'
import AssistantRepetitionReduceTag from '@img/student/assistant-repetition-reduce-tag.png'
import AssistantPaperDefenseTag from '@img/student/assistant-paper-defense-tag.png'

import CoachTitleBg from '@img/purchase/coach-title-bg.png'
import AigcTitleBg from '@img/purchase/aigc-title-bg.png'
import AdviseTitleBg from '@img/purchase/advise-title-bg.png'
import CorrectionTitleBg from '@img/purchase/correction-title-bg.png'
import { DEFAULT_VALUE, EMPTY_VALUE } from '@/constants/thesis'

export const enum USER_ROLE {
  student = 'student',
  teacher = 'teacher',
}

export const SCHOOL_USER_ROLE = Object.freeze({
  student: 1,
  teacher: 2,
})

export const THESIS_PAPER_STATUS = Object.freeze(new Constant({
  All: { label: '全部', value: DEFAULT_VALUE, status: 'common' },
  Empty: { label: '-', value: EMPTY_VALUE, status: 'common' },
  UnSubmit: { label: '未提交', value: 0, status: 'common' },
  Checking: { label: '检测结构中', value: 1, status: 'doing' },
  CheckFailed: { label: '结构检测失败', value: 2, status: 'error' },
  ToAdvise: { label: '待指导', value: 3, status: 'error' },
  Advising: { label: '指导中', value: 4, status: 'doing' },
  AdvisorFailed: { label: '未通过', value: 5, status: 'error' },
  AdvisorPassed: { label: '通过', value: 6, status: 'common' },
  ToReview: { label: '待评审', value: 7, status: 'error' },
  Reviewing: { label: '评审中', value: 8, status: 'doing' },
  ReviewFailed: { label: '评审未通过', value: 9, status: 'error' },
  ReviewPassed: { label: '评审通过', value: 10, status: 'common' },
  Coaching: { label: '辅导中', value: 11, status: 'doing' },
  CoachComplete: { label: '辅导完成', value: 12, status: 'common' },
}))
export const ADVISOR_STATUS = Object.freeze(
  new Constant({
    All: THESIS_PAPER_STATUS.enums.All,
    Empty: THESIS_PAPER_STATUS.enums.Empty,
    ToAdvise: THESIS_PAPER_STATUS.enums.ToAdvise,
    Advising: THESIS_PAPER_STATUS.enums.Advising,
    AdvisorFailed: THESIS_PAPER_STATUS.enums.AdvisorFailed,
    AdvisorPassed: THESIS_PAPER_STATUS.enums.AdvisorPassed,
  }),
)
export const CHECK_STRUCTURE_STATUS = Object.freeze(
  new Constant({
    All: THESIS_PAPER_STATUS.enums.All,
    Empty: THESIS_PAPER_STATUS.enums.Empty,
    CHECKING: { label: '检测中', value: 1 },
    CHECK_FAIL: { label: '未通过', value: 2 },
    CHECK_SUCCESS: { label: '通过', value: 3 },
  }),
)

export const AI_ADVISOR_STATUS = Object.freeze(
  new Constant({
    All: THESIS_PAPER_STATUS.enums.All,
    Advised: { label: '已生成', value: 3 },
    UnAdvise: { label: '未生成', value: 1 },
    Advising: { label: '生成中', value: 2 },
  }),
)

export const enum PLATFORM_TYPE {
  version2 = 1,
  version3,
}

export const THESIS_PAPER_STATUS_V3 = Object.freeze(new Constant({
  Checking: { label: '检测结构中', value: 1, status: 'doing' },
  CheckFailed: { label: '结构检测失败', value: 2, status: 'error' },
  CheckSuccess: { label: '检测成功', value: 3, status: 'success' },
}))

export const AIGC_PAPER_STATUS_V3 = Object.freeze(new Constant({
  Wait: { label: '待解析', value: 0 },
  Analysis: { label: '解析中', value: 1 },
  AnalysisSuccess: { label: '解析成功', value: 2 },
  AnalysisFailed: { label: '解析失败', value: 3 },
  TransformFailed: { label: '转码失败', value: 5 },
}))

export const INIT_ID = -1

export const GUIDANCE_STATUS = Object.freeze(new Constant({
  UnSubmit: { label: '待提交', value: 0, class: 'error' },
  ToAdvise: { label: '待指导', value: 3, class: 'doing' },
  Advising: { label: '指导中', value: 4, class: 'doing' },
  AdvisorFailed: { label: '指导未通过', value: 5, class: 'error' },
  AdvisorPassed: { label: '指导通过', value: 6, class: 'success' },
}))

// V2
export const SERVICE_TYPE = Object.freeze(new Constant({
  Advise: { label: '指导', value: 1 },
  AdviseAndCoach: { label: '指导+辅导', value: 2 },
}))

// V3
export const ORDER_SERVICE_TYPE = Object.freeze(
  new Constant({
    FormatCorrection: {
      value: 1,
      label: '格式检测校正',
      tag: CorrectionTag,
      assistantTag: AssistantCorrectionTag,
      slogan: '精准识别格式问题，智能校正排版细节，轻松搞定论文规范。',
      keyword: '格式智能校正',
      subtitle: '排版至美，规范无忧轻松达标',
      subtitleKeyword: '排版至美',
      actionTitle: '一键格式检测校正',
      titleBg: CorrectionTitleBg,
      spent: 32,
      order: 2,
      titleOrder: 2,
    },
    Coach: {
      value: 2,
      label: '论文修改润色',
      tag: CoachTag,
      assistantTag: AssistantCoachTag,
      slogan: '迅速识别并直接修正论文瑕疵，轻松解放双手，加速论文高质量定稿。',
      keyword: '内容表达优化',
      subtitle: '内容至臻，语言优化高效定稿',
      subtitleKeyword: '内容至臻',
      actionTitle: '一键修改润色',
      titleBg: CoachTitleBg,
      spent: 64,
      order: 1,
      titleOrder: 1,
    },
    CorrectionAndCoach: { // 旧数据
      value: 3,
      label: '格式检测校正+内容修改润色',
      tag: CoachTag,
      assistantTag: '',
      slogan: '',
      keyword: '',
      subtitle: '',
      subtitleKeyword: '',
      actionTitle: '',
      titleBg: '',
      spent: 96,
      order: 99,
      titleOrder: 99,
    },
    Advise: {
      value: 4,
      label: '论文指导评阅',
      tag: AdviseTag,
      assistantTag: AssistantAdviseTag,
      slogan: '深度解析逻辑结构，精准定位评议要素，助力论文高效优化。',
      keyword: '精准定位短板',
      subtitle: '高效洞察，精准定位短板',
      subtitleKeyword: '高效洞察',
      actionTitle: '一键指导评阅',
      titleBg: AdviseTitleBg,
      spent: 0,
      order: 0,
      titleOrder: 0,
    },
    AigcCheck: {
      value: 5,
      label: 'AIGC检测',
      tag: AigcTag,
      assistantTag: AssistantAigcTag,
      slogan: '精准筛查AI生成痕迹，学术原创全程护航，论文诚信无忧保障。',
      keyword: 'AI生成严审',
      subtitle: '原创无忧，AI生成无处遁形。',
      subtitleKeyword: '原创无忧',
      actionTitle: '一键 AIGC 检测',
      titleBg: AigcTitleBg,
      spent: 0,
      order: 4,
      titleOrder: 4,
    },
    AigcReduce: {
      value: 6,
      label: '降AIGC率',
      tag: AigcReduceTag,
      assistantTag: AssistantAigcreduceTag,
      slogan: '秒级定位AI痕迹，智能改写自然流畅，原创率精准达标。',
      keyword: 'AI内容净化',
      subtitle: '宛若真人，AI生成内容智能净化',
      subtitleKeyword: '宛若真人',
      actionTitle: '降AIGC率',
      titleBg: '',
      spent: 0,
      order: 5,
      titleOrder: 7,
    },
    FormatDetection: {
      value: 7,
      label: '格式检测',
      tag: DetectionTag,
      assistantTag: AssistantDetectionTag,
      slogan: '精准定位格式漏洞，全面扫描排版偏差，轻松锁定修改方向。',
      keyword: '格式智能检测',
      subtitle: '规范无忧，精准定位每一处疏漏。',
      subtitleKeyword: '格式规范',
      actionTitle: '一键格式检测',
      titleBg: '',
      spent: 16,
      order: 3,
      titleOrder: 3,
    },
    RepetitionReduce: {
      value: 8,
      label: '降重',
      tag: RepetitionReduceTag,
      assistantTag: AssistantRepetitionReduceTag,
      slogan: '秒级定位重复内容，智能改写语义无损，助力论文无忧通关。',
      keyword: '杜绝原文复用',
      subtitle: '查重无虞，相似内容智能重塑。',
      subtitleKeyword: '查重无虞',
      actionTitle: '降重',
      titleBg: '',
      spent: 0,
      order: 6,
      titleOrder: 5,
    },
    PaperDefense: {
      value: 9,
      label: '答辩材料',
      tag: PaperDefenseTag,
      assistantTag: AssistantPaperDefenseTag,
      slogan: '系统整合论文价值，智能预判导师提问，答辩准备全程无忧。',
      keyword: '答辩智能准备',
      subtitle: '专业高效，智能输出整套答辩材料。',
      subtitleKeyword: '高效答辩',
      actionTitle: '生成PPT大纲',
      titleBg: '',
      spent: 0,
      order: 7,
      titleOrder: 6,
    },
  }),
)

// 接入论文公共服务
export const THESIS_SERVICE_TYPE_LIST = [
  ORDER_SERVICE_TYPE.enums.AigcReduce.value,
  ORDER_SERVICE_TYPE.enums.RepetitionReduce.value,
  ORDER_SERVICE_TYPE.enums.PaperDefense.value,
]

export const enum BUSINESS_TYPE {
  Aigc = 1,
}

export const ORDER_STATUS = Object.freeze(
  new Constant({
    Wait: {
      value: 0,
      label: '待支付',
    },
    Paid: {
      value: 1,
      label: '已支付',
    },
    Refund: {
      value: 4,
      label: '已退款',
    },
    Invalid: {
      value: 7,
      label: '已失效',
    },
  }),
)

export const PAPER_TASK_STATUS = Object.freeze(
  new Constant({
    InProgress: {
      value: 2,
      label: '进行中',
      name: 'in-progress',
    },
    Finished: {
      value: 3,
      label: '已完成',
      name: 'finished',
    },
    Failed: {
      value: 4,
      label: '失败',
      name: 'failed',
    },
  }),
)

export const AIGC_REDUCE_STATUS = Object.freeze({
  Uploaded: 1,
  Analysis: 2,
  UnPay: 3,
  Paid: 4,
})
